import { H5P } from 'h5p-standalone';
import 'expose-loader?h5pFrame!h5p-standalone/dist/frame.bundle';

const $el = document.getElementById('h5p-container');


if ($el) {
  
  const h5pLocation = $el.dataset.url;

  const options = {
    // id: 'lesson-one', // Optional unique ID, by default will be randomly generated
    // frame.bundle with cache buster we should update when we change h5p version
    frameJs: $el.dataset.path + 'frame.bundle.js?v=3.0.3',
    frameCss: $el.dataset.path + 'styles/h5p.css?v=3.0.3',
    h5pJsonPath: h5pLocation,
    frame: false,
    copyright: false,
    embed: false,
    download: false,
    icon: false,
    export: false
  };

  const h5p = new H5P($el, options);
  const threshold = parseInt($el.dataset.threshold)/100;

  // Jitter sollution, it happens because of iframe body scroll
  // either this or a fork with overflow: hidden on html.h5p-frame
  // this does not allow for page resize after render
  const resizeIframe = (e) => {
    console.log('resize iframe');
    let width = document.querySelector('.js-h5p-container iframe').contentWindow.innerWidth;
    let height = document.querySelector('.js-h5p-container iframe').contentWindow.innerHeight;
    let current_ratio = (width/height).toFixed(1);

    // only resize container for 1.7 16:9 ratio
    if (current_ratio === "1.7") {
      document.querySelector('.js-h5p-container').style.margin = '0 auto';
      document.querySelector('.js-h5p-container').style.maxWidth =  parseInt( (height*1.7777)-64) +'px';
    }

  }


  h5p.then(() => {
    document.querySelector('.js-h5p-container iframe').onload = function() {

      document.querySelector('.js-h5p-loader').remove();
      document.querySelector('.js-h5p-container').classList.remove('hide');
      this.contentWindow.addEventListener('resize', resizeIframe);
      this.contentWindow.addEventListener('domChanged', resizeIframe);

      // Fixes #174841324 not sure what will imply for some h5p's
      this.contentDocument.body.style.overflow = 'hidden';

      // fix for when there are youtube videos
      // https://h5p.org/node/204363
      window.dispatchEvent(new Event('resize'));

      setTimeout(function() {
        resizeIframe();
      }, 100);

      window.H5P.externalDispatcher.on('xAPI', function (event) {
        console.log('xAPI event: ' + JSON.stringify(event));
        window.eve = event; //debugging line
        // This huge if means that it is a completed event with results and does not belong to any parent
        // ex: does not trigger on quizes inside a video
        if ( event.data.statement &&
            event.data.statement.context &&
            event.data.statement.context.contextActivities &&
            !event.data.statement.context.contextActivities.parent &&
            event.data.statement.result) {
          console.log('Checking score...');
          console.log(event.data.statement.result.score);

          if ( event.data.statement.result.score.scaled >= threshold ) {
           console.log( 'Upload progress user passed sending progress event');
           let data = {
            event: 'h5p_complete',
            segment_id: $("#unit").data("id"),
            unit_resource_id: $el.dataset.unitResourceId
            };

            $.ajax({
              type: "POST",
              async: true,
              url: "/registerevent",
              data: data,
              success: function(data) {}
            });

          } else {
           console.log( 'User failed');
          }
        }

        if (event.data.statement.result) {
          console.log('It\'s a completed event.');
          // Send to server. . . .
        }
      });
    };
  });

}